import React, { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../redux/slices/userSlice";
import LoaderImg from "../auditor/favicon.svg";

const LoginRedirect = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        // check if the user has a valid session
        // if they do, redirect to dashboard
        // else, redirect to login
        const checkSession = async () => {
            try {
                const checkRes = await axios.get("/auditor/business/account/checkSession");
                const isLoggedIn = checkRes.data.logged_in;

                if (isLoggedIn) return handleLogin();
                return handleError();
            } catch(error) {
                handleError();
            }
        }
        checkSession();
    }, [])

    const handleLogin = () => {
        dispatch(login());
        navigate("/dashboard");
    }

    const handleError = () => {
        window.location.replace("/signin")
    }

    return (
        <div className="loader loading">
            <img src={LoaderImg} alt="loader" />
        </div>
    );
}

export default LoginRedirect;